const ProductListStyles = {
    baseStyle: {
        page: {
            paddingTop: 0,
            paddingBottom: '20px',
            paddingLeft: 0,
            paddingRight: 0,
            maxWidth: '100vw',
            paddingInlineStart: 0,
            paddingInlineEnd: 0
        },
        header: {
            wrapper: {
                paddingLeft: {base: '15px', lg: '60px', xl: '60px'},
                paddingRight: {base: '15px', lg: '60px', xl: '60px'},
                display: {base: 'none', lg: 'flex'},
                direction: 'row',
                justify: 'space-between',
                align: 'flex-start',
                spacing: 4,
                marginBottom: 6
            },
            flex: {
                align: 'left',
                width: '60%'
            }
        },
        body: {
            main: {
                display: 'flex',
                width: '-webkit-fill-available',
                justifyContent: 'flex-start',
                marginTop: 0
            },
            productsGrid: {
                columns: [2, 2, 4, 4],
                gridRowGap: {base: '30px', lg: '70px'},
                spacingX: {base: '2px', md: '4px', lg: '6px'},
                templateColumns: {
                    base: 'repeat(2, minmax(0, 50%))',
                    md: 'repeat(4, minmax(0, 25%))',
                    lg: 'repeat(4, minmax(0, 25%))'
                },
                marginBottom: {base: '30px', lg: '70px'},
                spacingY: {base: 12, lg: 16},
                minHeight: {base: '600px', lg: '800px'},
                position: {base: 'relative', lg: 'static'},
                zIndex: {base: 1, lg: 'auto'}
            },
            totalItems: {
                main: {
                    width: '-webkit-fill-available'
                },
                text: {
                    color: 'black.300',
                    fontSize: '14px',
                    fontWeight: '300',
                    textAlign: 'end'
                }
            },
            refineSortWrapper: {
                main: {
                    display: {base: 'flex', lg: 'none'},
                    flexDirection: 'row',
                    zIndex: 2,
                    transition: 'top 0.3s ease',
                    direction: 'row',
                    justify: 'stretch',
                    align: 'center',
                    spacing: 1,
                    height: 'auto'
                },
                filter: {
                    color: 'black',
                    display: {base: 'flex', lg: 'none'},
                    alignItems: 'baseline'
                },
                allFilters: {
                    color: 'black',
                    display: {base: 'none', lg: 'block'}
                },
                selectedFilters: {
                    marginLeft: '15px',
                    marginRight: '15px',
                    backgroundColor: 'gray.50',
                    borderRadius: '50%',
                    fontSize: '13px',
                    fontFamily: 'body',
                    alignContent: 'center',
                    width: '29px',
                    height: '29px',
                    textAlign: 'center'
                },
                filterIcon: {
                    width: '18px',
                    height: '18px'
                },
                flex: {
                    align: 'center',
                    display: {lg: 'none'},
                    width: '100%'
                },
                button: {
                    fontSize: '16px',
                    colorScheme: 'black',
                    fontFamily: 'body',
                    fontWeight: '300',
                    variant: 'outline',
                    margin: '0',
                    padding: '0 15px',
                    gap: '7px',
                    borderColor: 'black.300 !important',
                    height: {base: '44px', lg: '52px'},
                    border: '1px solid',
                    _hover: {bg: 'transparent'},
                    display: 'inline-flex',
                    justifyContent: 'center',
                    width: '100%'
                },
                selectedRefinements: {
                    main: {
                        marginBottom: {base: 0, lg: 4},
                        marginTop: {base: '20px', lg: 0},
                        marginLeft: {base: '15px', lg: 0},
                        marginRight: {base: '15px', lg: 0},
                        display: {base: 'block', lg: 'none'}
                    },
                    button: {
                        margin: '0 0 10px 0',
                        color: 'black',
                        backgroundColor: 'gray.400',
                        borderRadius: '3px',
                        colorScheme: 'gray',
                        fontSize: {base: '14px', lg: '16px'},
                        fontWeight: '300',
                        fontFamily: 'body',
                        _hover: {
                            color: 'black',
                            backgroundColor: 'gray.400'
                        },
                        _active: {
                            color: 'black',
                            backgroundColor: 'gray.400'
                        },
                        _focus: {
                            color: 'black',
                            backgroundColor: 'gray.400'
                        },
                        transition: 'color 0.3s ease',
                        padding: '14px',
                        width: 'max-content',
                        iconSpacing: 1
                    }
                }
            },
            colorRefinements: {
                stack: {
                    border: '1px solid',
                    className: 'colors-stack',
                    padding: '10px',
                    cursor: 'pointer'
                },
                text: {
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '16px',
                    fontWeight: '300',
                    color: 'black.100',
                    marginBottom: '1px'
                },
                button: {
                    borderColor: 'black',
                    variant: 'outline',
                    marginRight: 0,
                    marginBottom: '-1px'
                },
                buttonBox: {
                    marginRight: '0',
                    height: '100%',
                    width: '100%',
                    minWidth: '32px',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }
            },
            refinementsModal: {
                content: {
                    borderRadius: {base: '20px 20px 0 0 !important', md: '0 !important'},
                    height: '100%',
                    maxHeight: {base: '85%', md: '100%'},
                    width: {base: '100%', md: '414px'},
                    maxWidth: {base: '100%', md: '414px'}
                }
            },
            sortForm: {
                control: {
                    border: '1px solid var(--chakra-colors-gray-600)',
                    borderColor: 'gray.600',
                    height: {base: '44px', lg: '52px'},
                    borderRadius: '3px',
                    alignContent: 'center',
                    padding: '0'
                },
                selectTag: {
                    textAlign: 'left',
                    margin: 'unset',
                    height: 'fit-content',
                    border: 'none',
                    color: 'black.100'
                },
                selectIcon: {
                    width: '13px !important',
                    height: '13px !important'
                }
            },
            refinements: {
                arrowImage: {
                    color: 'black',
                    width: '13px',
                    height: '13px',
                    verticalAlign: 'middle'
                }
            }
        },
        footer: {
            justifyContent: ['center', 'center', 'flex-start']
        },
        modal: {
            footer: {
                display: {base: 'block', md: 'none'},
                width: 'full',
                borderTop: '1px solid',
                background: 'white',
                borderColor: 'gray.500',
                padding: '20px 20px 10px 20px'
            }
        },
        noSrp: {
            page: {
                direction: 'column',
                alignItems: 'baseline',
                textAlign: 'left',
                width: '100%',
                maxWidth: '1320px',
                margin: '0 auto',
                padding: {base: '0px 15px 60px 15px', lg: '0px 0px 60px 0px'},
                minHeight: {base: '600px', lg: '800px'}
            },
            heading: {
                color: 'black.100',
                fontSize: '29px',
                fontWeight: '400',
                margin: '15px 15px 15px 0px',
                letterSpacing: '0.145px'
            },
            description: {
                color: 'black.100',
                fontSize: '16px',
                fontWeight: '300',
                margin: '0px 15px 0px 0px',
                lineHeight: '25px',
                letterSpacing: '0.08px'
            },
            queryCorrection: {
                main: {
                    gap: '10px',
                    width: 'fit-content',
                    display: 'contents',
                    alignItems: 'center',
                    cursor: 'pointer'
                },
                text1: {
                    color: 'teal.600',
                    textUnderlineOffset: '4px',
                    textDecoration: 'underline',
                    fontWeight: '300',
                    fontSize: '16px',
                    letterSpacing: '0.08px'
                },
                text2: {
                    color: 'black.100',
                    fontSize: '16px',
                    lineHeight: '25px',
                    width: 'fit-content',
                    letterSpacing: '0.08px',
                    fontWeight: '300'
                }
            }
        }
    }
}

export default ProductListStyles
